// Generated by scripts/mdi/import-questionnaires.mjs from MDI "2. Tirzepatide + B6 Initial 09.17.26" (68f1d4e3-b4db-4ba0-865c-5946431de5ba). Re-run instead of editing.
import { QuestionAnswerMap } from '@care-portals/api-interfaces';

const mdiTirzepatideB6InitialQuestions = [
  {
    field: 'mdiTirzepatideB6Initial_state',
    label: 'Which state do you live in?',
    type: 'select',
    extras: { sendToBeluga: false, sendToMdi: false, mdiRouting: true },
    answer: {
      type: 'single_select',
      options: [
        { key: 'la', value: 'Louisiana' },
        { key: 'ms', value: 'Mississippi' },
        { key: 'other', value: 'Another state' }
      ]
    }
  },
  {
    field: 'mdiTirzepatideB6Initial_considerTreatmentGlp1AppropriateReasons',
    label:
      'We will consider you for treatment with a GLP1 if it is appropriate. Which reasons are you consulting for?',
    type: 'select',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'microdosing_for_general_health',
          value: 'Microdosing for general health'
        },
        { key: 'longevity', value: 'Longevity' },
        { key: 'anti_inflammatory', value: 'Anti-inflammatory' },
        { key: 'support_healthy_weight', value: 'Support healthy weight' },
        { key: 'cardiovascular_benefit', value: 'Cardiovascular benefit' },
        { key: 'neurocognitive_benefit', value: 'Neurocognitive benefit' },
        {
          key: 'other_please_specify',
          value: 'Other (please specify)',
          answer: {
            type: 'text',
            name: 'other_please_specify_details',
            placeholder: 'Please specify'
          }
        }
      ]
    },
    extras: { mdiQuestionId: 'be7d1b0a-4ebc-4065-9828-7e5ebe4c156e' }
  },
  {
    field: 'mdiTirzepatideB6Initial_takingPrescriptionMedications',
    label:
      'Are you CURRENTLY taking any of the following PRESCRIPTION medications?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'wegovy_zepbound_mounjaro_ozempic_trulici',
          value: 'Wegovy/Zepbound/Mounjaro/Ozempic/Trulicity/Saxenda'
        },
        { key: 'compounded_semaglutide', value: 'Compounded Semaglutide' },
        { key: 'compounded_tirzepatide', value: 'Compounded tirzepatide' },
        { key: 'other_drug_not_listed', value: 'Other drug not listed' },
        { key: 'none_at_this_time', value: 'None at this time' }
      ]
    },
    extras: { mdiQuestionId: '5372e478-8a06-499e-ae8e-dc24ccb1de03' }
  },
  {
    field: 'mdiTirzepatideB6Initial_otherMedicationTaking',
    label: 'What other medication are you taking?',
    type: 'info',
    subLabel:
      'You answered you take a different medication to support weight loss.  Please give the name, dose and date of the medication you are taking.',
    answer: {
      type: 'text',
      name: 'mdiTirzepatideB6Initial_otherMedicationTaking',
      rows: 4,
      placeholder:
        'Example: I am taking medication A at 10 mg per day which I started 1 month ago.'
    },
    extras: { mdiQuestionId: '2949e142-85fe-4e54-a01a-18b44670387e' }
  },
  {
    field: 'mdiTirzepatideB6Initial_typeDrugInformationFoundLabel',
    label:
      'Please type ALL of the drug information which is found on the label of your CURRENT medication',
    type: 'info',
    subLabel:
      '• Name of medication\n• Form and strength/concentration (ex: 2.5 mg/mL vial, 500 mg tablet, 5 mg capsule)\n• Your current dose and instructions (ex: Inject 20 units weekly, take 1 tablet daily by mouth)\n• Would you like to stay at your current dose, or discuss an increase/decrease?',
    answer: {
      type: 'text',
      name: 'mdiTirzepatideB6Initial_typeDrugInformationFoundLabel',
      rows: 4,
      placeholder:
        'Ex: Semaglutide. 2.5mg/mL. 20 units. Last injected 3/20/23. Stay the same dose'
    },
    extras: { mdiQuestionId: 'cad418a7-001c-4634-88cc-60e242ae1e83' }
  },
  {
    field: 'mdiTirzepatideB6Initial_takePictureCurrentPrescriptionMedication',
    label: 'Take a picture of your current prescription/medication',
    type: 'file_upload',
    subLabel:
      '•  Must include your name on the prescription\n•  You may add pictures later if you cannot provide at this time.',
    accepts: [
      'image/jpeg',
      'image/jpg',
      'image/webp',
      'image/png',
      'application/pdf'
    ],
    answer: [
      {
        resourceId:
          'mdiTirzepatideB6Initial_takePictureCurrentPrescriptionMedication',
        buttonLabel: 'Upload',
        required: false
      }
    ],
    required: false,
    extras: { mdiQuestionId: '8c444255-54e4-4878-bd32-d9d67cca8d31' }
  },
  {
    field: 'mdiTirzepatideB6Initial_dateLastDose',
    label: 'What is the date of your last dose?',
    type: 'info',
    answer: { type: 'date', name: 'mdiTirzepatideB6Initial_dateLastDose' },
    extras: { mdiQuestionId: '9bb2f0bc-060b-414f-92ab-5f70d67f3c53' }
  },
  {
    field: 'mdiTirzepatideB6Initial_labTestsCompletedWithinLast',
    label:
      'Have you had any lab tests completed within the last 6 months that you would like to share with your doctor?',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'yes', value: 'Yes' },
        { key: 'no_not_at_this_time', value: 'No, not at this time' }
      ]
    },
    extras: { mdiQuestionId: '5f108146-799c-43e8-9a5a-0b206994bb59' }
  },
  {
    field: 'mdiTirzepatideB6Initial_doctorOnlyNeedsSeeCholesterol',
    label:
      'Your doctor only needs to see cholesterol levels, TSH (thyroid test), Ha1c, and Creatinine (kidney function).',
    type: 'file_upload',
    subLabel:
      'Any additional labs which you upload will not be reviewed.&#160; The doctor who ordered these labs is responsible for interpreting them.',
    accepts: [
      'image/jpeg',
      'image/jpg',
      'image/webp',
      'image/png',
      'application/pdf'
    ],
    answer: [
      {
        resourceId: 'mdiTirzepatideB6Initial_doctorOnlyNeedsSeeCholesterol',
        buttonLabel: 'Upload'
      }
    ],
    extras: { mdiQuestionId: '86746f9b-6f25-430e-a14d-ae190ecfa336' }
  },
  {
    field: 'mdiTirzepatideB6Initial_highCholesterol',
    label: 'Do you have any of the following?',
    type: 'select',
    educationalSlide:
      "These are considered 'co-morbidities' by the American Board of Obesity Medicine.  While you may not need to have one of these for treatment, your doctor would like to know.",
    answer: {
      type: 'multi_select',
      options: [
        { key: 'high_cholesterol', value: 'High cholesterol' },
        { key: 'fatty_liver_disease', value: 'Fatty Liver Disease' },
        { key: 'high_blood_pressure', value: 'High Blood Pressure' },
        { key: 'obstructive_sleep_apnea', value: 'Obstructive sleep apnea' },
        {
          key: 'pre_diabetes_type_2_diabetes_hba1c_above',
          value: 'Pre-diabetes/ Type 2 Diabetes / Hba1c above 5.7'
        },
        { key: 'none_of_the_above', value: 'None of the above' }
      ]
    },
    extras: { mdiQuestionId: 'f11e783c-c1f9-4c14-b454-3b1e1193b598' }
  },
  {
    field: 'mdiTirzepatideB6Initial_chronicPancreatitisPrevious',
    label: 'Do you have any of the following?',
    type: 'select',
    educationalSlide:
      'If yes to any, please provide your doctor with more insight. You may include most recent labs, last time you saw a specialist, provide as much detail as possible.',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'chronic_pancreatitis_or_previous_episode',
          value: 'Chronic pancreatitis or previous episode of pancreatitis',
          answer: {
            type: 'text',
            name: 'chronic_pancreatitis_or_previous_episode_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'history_of_type_1_diabetes',
          value: 'History of type 1 diabetes',
          answer: {
            type: 'text',
            name: 'history_of_type_1_diabetes_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'history_of_severe_gi_disease_ex_chrons_d',
          value:
            'History of severe GI disease (Ex: chrons disease, or ulcerative colits)',
          answer: {
            type: 'text',
            name: 'history_of_severe_gi_disease_ex_chrons_d_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'history_of_diabetic_retinopathy',
          value: 'History of diabetic retinopathy',
          answer: {
            type: 'text',
            name: 'history_of_diabetic_retinopathy_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'history_of_medullary_thyroid_cancer_or_a',
          value: 'History of medullary thyroid cancer (or a family history of)',
          answer: {
            type: 'text',
            name: 'history_of_medullary_thyroid_cancer_or_a_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'recent_bariatric_surgery_or_other_gi_sur',
          value:
            'Recent bariatric surgery or other GI surgery(less than 6 months ago)',
          answer: {
            type: 'text',
            name: 'recent_bariatric_surgery_or_other_gi_sur_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'history_or_family_history_of_men_2_multi',
          value:
            'History or family history of MEN-2 (multiple endocrine neoplasia syndrome type 2)',
          answer: {
            type: 'text',
            name: 'history_or_family_history_of_men_2_multi_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'history_of_gallbladder_disease_not_inclu',
          value:
            'History of gallbladder disease (not including gallbladder removal/cholecystectomy)',
          answer: {
            type: 'text',
            name: 'history_of_gallbladder_disease_not_inclu_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'liver_disease_cirrhosis',
          value: 'Liver disease/cirrhosis',
          answer: {
            type: 'text',
            name: 'liver_disease_cirrhosis_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'pyridoxine_b6_sensitivity_or_allergy',
          value: 'Pyridoxine (B6) sensitivity or allergy',
          answer: {
            type: 'text',
            name: 'pyridoxine_b6_sensitivity_or_allergy_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'benzyl_alcohol_sensitivity_or_allergy',
          value: 'Benzyl alcohol sensitivity or allergy',
          answer: {
            type: 'text',
            name: 'benzyl_alcohol_sensitivity_or_allergy_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'none_of_the_above', value: 'NONE of the above' }
      ]
    },
    extras: { mdiQuestionId: '427e466a-15a6-4689-a30f-85df9c3f5c59' }
  },
  {
    field: 'mdiTirzepatideB6Initial_historyKidneyFailure',
    label: 'Do you have any of the following?',
    type: 'select',
    educationalSlide:
      'If yes to any, please provide your doctor with more insight. You may include most recent labs, last time you saw a specialist, provide as much detail as possible.',
    answer: {
      type: 'multi_select',
      options: [
        {
          key: 'history_of_kidney_failure',
          value: 'History of kidney failure',
          answer: {
            type: 'text',
            name: 'history_of_kidney_failure_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'history_of_chronic_renal_failure',
          value: 'History of chronic renal failure',
          answer: {
            type: 'text',
            name: 'history_of_chronic_renal_failure_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'seen_a_kidney_specialist_in_the_past_12',
          value: 'Seen a kidney specialist in the past 12 months',
          answer: {
            type: 'text',
            name: 'seen_a_kidney_specialist_in_the_past_12_details',
            placeholder: 'Please specify'
          }
        },
        {
          key: 'history_of_solitary_kidney_or_kidney_tra',
          value: 'History of solitary kidney, or kidney transplant',
          answer: {
            type: 'text',
            name: 'history_of_solitary_kidney_or_kidney_tra_details',
            placeholder: 'Please specify'
          }
        },
        { key: 'none_of_the_above', value: 'NONE of the above' }
      ]
    },
    extras: { mdiQuestionId: '41b7dd54-4c39-463b-8da7-e0d061dabd31' }
  },
  {
    field: 'mdiTirzepatideB6Initial_likePrescriptionNauseaMedicationSent',
    label:
      'Would you like a prescription of nausea medication to be sent to your local pharmacy?',
    type: 'select',
    educationalSlide:
      'Nausea medication is not covered through this program and therefore will be an extra cost, but generally, is not an expensive medication.',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes_i_understand_this_is_different_than',
          value:
            'Yes. I understand this is different than the medication to help with appetite suppression/weight loss which will be sent directly to me. I will need to go pick this up and pay for it with my own insurance or out of pocket.'
        },
        { key: 'no_thank_you', value: 'No, thank you' }
      ]
    },
    extras: { mdiQuestionId: 'b3690091-9873-482b-813c-7b1148e468e3' }
  },
  {
    field: 'mdiTirzepatideB6Initial_readInformationAboutPersonalizedTreatment',
    label:
      'Please read the following information about your personalized treatment and you can proceed if you agree.',
    type: 'select',
    educationalSlide:
      'Do you agree that you would like your doctor to treat you with a personalized compounded-GLP1 treatment plan and be able to easily adjust your dose during your treatment? GLP-1 treatments may cause nausea. Would you like your treatment to be compounded with an additive that may help limit this side effect so that it will be easier for you to continue on your treatment plan without interruptions? Do you also agree that you would like to have dosing flexibility for your doctor to personalize your treatment and more control over your injections?',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'yes_i_have_read_the_above_and_agree_that',
          value:
            'Yes, I have read the above and agree that I would like my doctor to create a personalized treatment plan for me to reduce the possibility of any side effects and help me adhere to my treatment plan.'
        }
      ]
    },
    extras: { mdiQuestionId: '237e02d8-a7c8-40a8-bb9b-57e8b7209387' }
  },
  {
    field: 'mdiTirzepatideB6Initial_importantClickAttachedLinkReview',
    label:
      'IMPORTANT: please click the attached link to review the consent for your GLP1 treatment plan. By typing your name into the signature field you are attesting that you have read and understand this consent in its entirety.',
    type: 'info',
    subLabel:
      'Please click this link to view the GLP1 consent (https://drive.google.com/file/d/1LRpyB2kfqesrrWWPEX2UvsP6639nQrID/view)\n\nPlease type your full legal name below to proceed.',
    answer: {
      type: 'text',
      name: 'mdiTirzepatideB6Initial_importantClickAttachedLinkReview',
      placeholder: 'Type your full legal name to proceed'
    },
    extras: { mdiQuestionId: '71004bd0-3589-44e0-a5e2-d5df17ff5475' }
  },
  {
    field: 'mdiTirzepatideB6Initial_heresFirstMessageDoctorIntroduce',
    label:
      'Here’s your first message to your doctor. Please introduce yourself and feel free to:',
    type: 'info',
    subLabel:
      '-Ask any questions you have\n	- List any medical problem you have which were not discussed above\n- Include anything else you would like the doctor to know.',
    answer: {
      type: 'text',
      name: 'mdiTirzepatideB6Initial_heresFirstMessageDoctorIntroduce',
      rows: 4,
      placeholder:
        "Hi doctor, I've had trouble losing weight since I was a teenager and am excited to start my weight loss journey."
    },
    extras: { mdiQuestionId: '80f8a767-bd9c-47de-a87b-87787672e8e1' }
  },
  {
    field: 'mdiTirzepatideB6Initial_complete',
    label:
      'Thank you for completing this questionnaire, please select "Finish" to submit',
    type: 'info',
    isLast: true,
    answer: {},
    extras: { sendToBeluga: false, sendToMdi: false }
  }
] as const;

export type mdiTirzepatideB6InitialAnswerField = Partial<
  QuestionAnswerMap<typeof mdiTirzepatideB6InitialQuestions>
>;

export default mdiTirzepatideB6InitialQuestions;
